export default "__VITE_ASSET__CELrPX6B__"